/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ErrorType } from "../../../model/common";
import { WsNewrequestCreation, WsSortedType } from "../../../model/statergyWS";

export interface GetwsStrategyList {
  loading: boolean;
  data: WsSortedType[] | null;
  status: number;
  error: boolean;
}

export const initialState: GetwsStrategyList = {
  loading: false,
  data: null,
  status: 0,
  error: false,
};

const statergyUpdateSlice = createSlice({
  name: "statergyUpdateSlice",
  initialState,
  reducers: {
    reset: () => initialState,
    strategyUpdateRequest(
      state: GetwsStrategyList,
      action: PayloadAction<{
        data: { workStreams: WsSortedType[] };
        assesmentid: string;
      }>,
    ) {
      state.loading = true;
    },
    strategyUpdateSuccess(
      state: GetwsStrategyList,
      action: PayloadAction<{ data: WsSortedType[]; status: number }>,
    ) {
      state.loading = false;
      state.data = action.payload.data;
      state.status = action.payload.status;
    },
    strategyUpdateFailure(
      state: GetwsStrategyList,
      action: PayloadAction<{ error: ErrorType }>,
    ) {
      state.loading = false;
      state.error = true;
      state.status = action.payload.error.response.status;
    },
    workStreamCreateRequest(
      state: GetwsStrategyList,
      action: PayloadAction<{ newData: WsNewrequestCreation }>,
    ) {
      state.loading = true;
    },
  },
});

export const strategyUpdateAction = statergyUpdateSlice.actions;
export const strategyUpdateReducer = statergyUpdateSlice.reducer;

export default strategyUpdateReducer;
